import { PrismicPageParser } from "../../shared/utils/prismicPageParser"
import cx from "classnames"
import styles from "./HomeContainer.module.scss"

const HomeContainer = () => {
  const data = JSON.parse(window.prismic_data)
  const pageId = window.pageId

  return (
    <section id="mm-home-new" className={cx(styles.home, "pageContainer")} aria-label="Home page">
      <PrismicPageParser pageData={data} pageId={pageId} pageName="Home" />
    </section>
  )
}

export default HomeContainer
